import React from "react";
import { Children, ReactElement, cloneElement } from "react";

/**
 * 레이어 그룹핑 props — 자식 컴포넌트들에 동일한 `zIndex` 를 일괄 적용.
 */
export interface LayerGroupProps {
  zIndex?: number;
  children: ReactElement | ReactElement[];
}

export function LayerGroup({ zIndex, children }: LayerGroupProps) {
  if (!Array.isArray(children) && zIndex) {
    const childElement = children as ReactElement;
    return cloneElement(childElement, { ...(childElement.props || {}), zIndex } as any);
  }
  if (Array.isArray(children) && zIndex) {
    return (
      <>
        {Children.map(children, (child) => {
          if (React.isValidElement(child)) {
            return cloneElement(child, { ...(child.props || {}), zIndex } as any);
          }
          return child;
        })}
      </>
    );
  }
  return <>{children}</>;
}
